<template>
  <aside class="_profile-subscriptions-column" v-if="mode !== 'yandex-pay-success'">
    <h5 class="_profile-column-title">Подписки</h5>
    <ul class="_profile-cards-subscription">
      <li class="_profile-card-subscription">
        <div class="_profile-card-inner">
          <div class="_profile-card-info">
            <h4 class="_profile-card-title">Журнал</h4>
            <div class="_profile-status-value" :class="{ 'not-active': user?.payment?.type !== 1 }">
              {{ status?.desc1 }}
            </div>
          </div>
          <template v-if="user.payment">
            <template v-if="user.payment.type === 1">
              <picture v-if="showInfoJournal">
                <source srcset="@/assets/img/lk-bg-card-subscription-mob.webp" media="(max-width: 725px)" />
                <img class="_profile-bg-card-subscription" src="@/assets/img/lk-bg-card-subscription.webp" />
              </picture>
              <picture v-else>
                <source srcset="@/assets/img/lk-bg-card-subscription-cut-mob.webp" media="(max-width: 725px)" />
                <img class="_profile-bg-card-subscription" src="@/assets/img/lk-bg-card-subscription-cut.webp" />
              </picture>
              <div class="_profile-manage" @click="() => openInfoJournal()">
                <p class="text">управлять</p>
                <template v-if="showInfoJournal">
                  <img src="@/assets/img/lk-double-up.svg" alt="double-up" />
                </template>
                <template v-else>
                  <img src="@/assets/img/lk-double-down.svg" alt="double-down" />
                </template>
              </div>
            </template>
            <template v-else>
              <a class="main-action-btn-small" href="/profile#change-payment-type">
                <span>Подключить </span>
              </a>
            </template>
          </template>
        </div>
        <template v-if="showInfoJournal">
          <div class="_profile-manage-settings">
            <ul class="_profile-nav">
              <li v-if="mode !== 'change-payment-type'">
                <a href="/profile#change-payment-type">
                  <img src="@/assets/img/lk-menu-payment-method.svg" alt="cart">
                  <span>Изменить способ оплаты </span>
                  <img class="_profile-nav-arr" src="@/assets/img/lk-menu-arrow.svg" alt="arrow">
                </a>
              </li>
              <template v-if="user.payment">
                <li v-if="user.payment.type === 1 || user.payment.type === 2">
                  <a href="/profile#confirm-cancel-subscription">
                    <img src="@/assets/img/lk-menu-cancel.svg" alt="cancel">
                    <span> Отключить услугу </span>
                    <img class="_profile-nav-arr" src="@/assets/img/lk-menu-arrow.svg" alt="arrow">
                  </a>
                </li>
              </template>
            </ul>
          </div>
        </template>
      </li>
      <li class="_profile-card-subscription">
        <div class="_profile-card-inner">
          <div class="_profile-card-info">
            <h4 class="_profile-card-title">Инвестиции</h4>
            <div class="_profile-status-value" :class="{ 'not-active': invType !== 1 }">
              {{ statusInv?.desc1 }}
            </div>
          </div>
          <template v-if="invType">
            <template v-if="invType === 1">
              <picture v-if="showInfoInvest">
                <source srcset="@/assets/img/lk-bg-card-subscription-mob.webp" media="(max-width: 725px)" />
                <img class="_profile-bg-card-subscription" src="@/assets/img/lk-bg-card-subscription.webp" />
              </picture>
              <picture v-else>
                <source srcset="@/assets/img/lk-bg-card-subscription-cut-mob.webp" media="(max-width: 725px)" />
                <img class="_profile-bg-card-subscription" src="@/assets/img/lk-bg-card-subscription-cut.webp" />
              </picture>
              <div class="_profile-manage" @click="() => openInfoInvest()">
                <p class="text">управлять</p>
                <template v-if="showInfoInvest">
                  <img src="@/assets/img/lk-double-up.svg" alt="double-up" />
                </template>
                <template v-else>
                  <img src="@/assets/img/lk-double-down.svg" alt="double-down" />
                </template>
              </div>
            </template>
            <template v-else>
              <ButtonAction class="main-action-btn-small" type="submit" message="Подключить"
                @buttonAction="activateInvestSubscription" />
            </template>
          </template>

        </div>
        <template v-if="showInfoInvest">
          <div class="_profile-manage-settings">
            <ul class="_profile-nav">
              <template v-if="invType">
                <li>
                  <a href="/profile#confirm-cancel-subscription-inv"> <img src="@/assets/img/lk-menu-cancel.svg"
                      alt="cancel">
                    <span>Отключить услугу</span>
                    <img class="_profile-nav-arr" src="@/assets/img/lk-menu-arrow.svg" alt="arrow">
                  </a>
                </li>
              </template>
            </ul>
          </div>
        </template>
      </li>
    </ul>
  </aside>
</template>

<script>
import ButtonAction from '@/components/newRedesign/UI/ButtonAction'

export default {
  props: {
    mode: {
      type: String,
      default: 'default'
    }
  },
  data: () => {
    return {
      statuses: {
        1: {
          color: "green",
          class: "profile-picture-0",
          description: "Услуга подключена и оплачена",
          desc1: "Услуга активна",
          desc1_color: "green",
          desc2: "Оплачено",
          desc2_color: "green",
        },
        2: {
          color: "yellow",
          class: "profile-picture-1",
          description: "Услуга подключена, но не оплачена",
          subDescription: "Стоимость услуги 12 руб.в день",
          desc1: "Услуга неактивна",
          desc1_color: "green",
          desc2: "Не оплачено",
          desc2_color: "red",
        },
        3: {
          color: "red",
          class: "profile-picture-2",
          description: "Услуга отключена",
          subDescription: "Стоимость услуги 12 руб.в день",
          desc1: "Услуга неактивна",
          desc1_color: "red",
          desc2: "Не оплачено",
          desc2_color: "red",
        },
      },
      showInfoJournal: false,
      showInfoInvest: false,
    }
  },
  components: {
    ButtonAction
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    status() {
      return this.statuses[this.$store.state?.user?.payment?.type];
    },
    statusInv() {
      return this.statuses[this.$store.state.user?.payment?.inv_type];
    },
    invType() {
      return this.$store.state.user?.payment?.inv_type;
    }
  },
  methods: {
    activateJournalSubscription() {
      this.$emit('activateJournalSubscription');
    },
    activateInvestSubscription() {
      this.$emit('activateInvestSubscription');
    },
    openInfoJournal() {
      this.showInfoJournal = !this.showInfoJournal;
    },
    openInfoInvest() {
      this.showInfoInvest = !this.showInfoInvest;
    }
  }
}
</script>
<style scoped lang="scss">
._profile-subscriptions-column {
  width: 667px;
  padding: 158px 0 0 59px;

  ._profile-column-title {
    width: 192px;
    font-family: 'Gilroy';
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 140%;
    color: #828282;
    border: none;
    padding-bottom: 6px;
    margin-bottom: 33px;
    border-bottom: 1px solid #828282
  }

  ._profile-cards-subscription {
    flex-direction: column;

    ._profile-card-subscription {
      position: relative;
      display: flex;
      flex-direction: column;
      width: 504px;
      min-height: 138px;
      padding: 38px 30px 20px;
      margin-bottom: 20px;
      background: #f2f2f2;
      border-radius: 12px;

      ._profile-card-inner {
        width: 100%;
        height: 71px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        ._profile-card-info {
          min-width: 157px;
          margin-right: 30px;
          font-family: 'Gilroy';
          font-style: normal;

          ._profile-card-title {
            padding: 0;
            margin-bottom: 8px;
            font-weight: 700;
            font-size: 20px;
            line-height: 24px;
            color: #333;
          }

          ._profile-status-value {
            font-weight: 500;
            font-size: 18px;
            line-height: 21px;
            color: #2f80ed;
          }

          ._profile-status-value.not-active {
            color: #333;
          }
        }

        ._profile-manage {
          position: absolute;
          top: 15px;
          right: 15px;
          width: 85px;
          padding: 2px 9px 6px;
          border-radius: 11px;
          background-color: #fff;
          cursor: pointer;

          .text {
            color: #22b491;
            font-size: 12px;
            font-weight: 500;
            line-height: normal;
            text-decoration: none;
          }

          img {
            position: absolute;
            top: 4px;
            right: 8px;
          }
        }

        .main-action-btn-small {
          display: block;
          width: 208px;
          height: 40px;
          padding: 11px 0 10px;
          background: #22B491;
          border: none;
          border-radius: 8px;
          font-family: Gilroy;
          font-style: normal;
          font-size: 16px;
          font-weight: 500;
          line-height: normal;
          color: #fff;
          text-align: center;
          cursor: pointer;
        }
      }

      ._profile-manage-settings {
        width: 100%;
        padding-block: 30px 10px;

        ._profile-nav-arr {
          display: none;
        }
      }

      ._profile-bg-card-subscription {
        width: 242px;
        position: absolute;
        top: 0;
        right: 0;
      }
    }
  }
}

@media screen and (max-width: 725px) {
  ._profile-subscriptions-column {
    width: 100%;
    flex-basis: 100%;
    border: 0;
    padding: 0;

    ._profile-cards-subscription {
      ._profile-card-subscription {
        width: 100%;
        padding: 24px 13px 20px;

        ._profile-card-inner {
          display: block;
          height: 94px;

          ._profile-card-info {
            margin-bottom: 14px;

            ._profile-card-title {
              font-weight: 700;
              margin-bottom: 4px;
              font-size: 18px;
              line-height: 22px;
              color: #333;
            }

            ._profile-status-value {
              font-weight: 500;
              font-size: 14px;
              line-height: 16px;
            }
          }

          ._profile-manage {
            top: 22px;
            right: 13px;
          }
        }

        ._profile-manage-settings {
          padding-block: 32px 10px;

          ._profile-nav-arr {
            display: block;
          }
        }

        ._profile-bg-card-subscription {
          width: 234px;
          position: absolute;
          top: 0;
          right: 0;
        }
      }
    }
  }

}
</style>
